import { EditIcon } from 'assets/images/svg';
import { useManagePermittedRoles } from 'library/hooks';
import { useState } from 'react';
import GrantPermissionsToDeviceModal from 'zComponents/molecules/GrantPermissionsToDeviceModal';
import { Button, Col, Row, Tooltip } from 'zui/Antd';

const AccessPermissionsPanelExtra = ({ deviceID, activeKeys, setActiveKeys, onModalOpenChange }) => {
	const canManagePermissions = useManagePermittedRoles('aCPermissionManagement');
	const permissionDeniedMessage = "You don't have permission to perform this action.";

	const [openModal, setOpenModal] = useState(false);

	const handleOpenModal = (e) => {
		e.stopPropagation();
		if (!canManagePermissions) return;
		setOpenModal(true);
		onModalOpenChange?.(true);
		if (!activeKeys.includes('permissions')) {
			setActiveKeys([...activeKeys, 'permissions']);
		}
	};

	const handleCloseModal = () => {
		setOpenModal(false);
		onModalOpenChange?.(false);
		setTimeout(() => {
			setActiveKeys((prev) => {
				if (!prev.includes('permissions')) {
					return [...prev, 'permissions'];
				}
				return prev;
			});
		}, 10);
	};

	return (
		<Row align='middle' gutter={[8, 8]}>
			<Col>
				<Tooltip title={!canManagePermissions ? permissionDeniedMessage : ''}>
					<span>
						<Button
							type='text'
							size='small'
							icon={<EditIcon color='currentColor' />}
							onClick={handleOpenModal}
							disabled={!canManagePermissions}
						/>
					</span>
				</Tooltip>
			</Col>
			<GrantPermissionsToDeviceModal visible={openModal} setVisible={handleCloseModal} deviceID={deviceID}>
				<div />
			</GrantPermissionsToDeviceModal>
		</Row>
	);
};

export default AccessPermissionsPanelExtra;
